import axios from 'axios'
import authHeader from './auth-header'

class TreeService {
  getTrees() {
    return axios.get(process.env.REACT_APP_API_URL + 'trees', {
      headers: authHeader(),
    })
  }

  getTree(idTree) {
    return axios.get(process.env.REACT_APP_API_URL + 'trees/' + idTree, {
      headers: authHeader(),
    })
  }
}

export default new TreeService()
